/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type GetClusterInviteInfoAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class GetClusterInviteInfoAuthClusterResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: GetClusterInviteInfoAuthClusterResponse429ResponseBodyData;

  constructor(
    err: GetClusterInviteInfoAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterInviteInfoAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type GetClusterInviteInfoAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class GetClusterInviteInfoAuthClusterResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: GetClusterInviteInfoAuthClusterResponse409ResponseBodyData;

  constructor(
    err: GetClusterInviteInfoAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterInviteInfoAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type GetClusterInviteInfoAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class GetClusterInviteInfoAuthClusterResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: GetClusterInviteInfoAuthClusterResponse404ResponseBodyData;

  constructor(
    err: GetClusterInviteInfoAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterInviteInfoAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type GetClusterInviteInfoAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class GetClusterInviteInfoAuthClusterResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: GetClusterInviteInfoAuthClusterResponseResponseBodyData;

  constructor(
    err: GetClusterInviteInfoAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterInviteInfoAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type GetClusterInviteInfoAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class GetClusterInviteInfoAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetClusterInviteInfoAuthClusterResponseBodyData;

  constructor(
    err: GetClusterInviteInfoAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterInviteInfoAuthClusterResponseBody";
  }
}

/**
 * Bad request
 */
export type GetClusterInviteInfoResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class GetClusterInviteInfoResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetClusterInviteInfoResponseBodyData;

  constructor(
    err: GetClusterInviteInfoResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetClusterInviteInfoResponseBody";
  }
}

/** @internal */
export const GetClusterInviteInfoAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    GetClusterInviteInfoAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetClusterInviteInfoAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetClusterInviteInfoAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterInviteInfoAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    GetClusterInviteInfoAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    GetClusterInviteInfoAuthClusterResponse429ResponseBody
  > = z.instanceof(GetClusterInviteInfoAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetClusterInviteInfoAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    GetClusterInviteInfoAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetClusterInviteInfoAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetClusterInviteInfoAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterInviteInfoAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    GetClusterInviteInfoAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    GetClusterInviteInfoAuthClusterResponse409ResponseBody
  > = z.instanceof(GetClusterInviteInfoAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetClusterInviteInfoAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    GetClusterInviteInfoAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetClusterInviteInfoAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetClusterInviteInfoAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterInviteInfoAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    GetClusterInviteInfoAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    GetClusterInviteInfoAuthClusterResponse404ResponseBody
  > = z.instanceof(GetClusterInviteInfoAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetClusterInviteInfoAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    GetClusterInviteInfoAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetClusterInviteInfoAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetClusterInviteInfoAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterInviteInfoAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    GetClusterInviteInfoAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    GetClusterInviteInfoAuthClusterResponseResponseBody
  > = z.instanceof(GetClusterInviteInfoAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetClusterInviteInfoAuthClusterResponseBody$inboundSchema:
  z.ZodType<
    GetClusterInviteInfoAuthClusterResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new GetClusterInviteInfoAuthClusterResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type GetClusterInviteInfoAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterInviteInfoAuthClusterResponseBody$outboundSchema:
  z.ZodType<
    GetClusterInviteInfoAuthClusterResponseBody$Outbound,
    z.ZodTypeDef,
    GetClusterInviteInfoAuthClusterResponseBody
  > = z.instanceof(GetClusterInviteInfoAuthClusterResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const GetClusterInviteInfoResponseBody$inboundSchema: z.ZodType<
  GetClusterInviteInfoResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetClusterInviteInfoResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetClusterInviteInfoResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetClusterInviteInfoResponseBody$outboundSchema: z.ZodType<
  GetClusterInviteInfoResponseBody$Outbound,
  z.ZodTypeDef,
  GetClusterInviteInfoResponseBody
> = z.instanceof(GetClusterInviteInfoResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
